import React from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../styles/FeatureDetail.css';

const FeatureDetail = ({ 
  title, 
  subtitle, 
  description, 
  icon, 
  benefits = [], 
  useCases = [],
  technologies = [],
  mainImage = "https://via.placeholder.com/800x400",
  screenshots = []
}) => {
  const navigate = useNavigate();

  return (
    <div className="feature-detail-page">
      {/* Hero Section */}
      <section className="feature-hero py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="d-flex align-items-center mb-3">
                {icon && <img src={icon} alt={title} className="feature-icon me-3" width="48" height="48" />}
                <h1>{title}</h1>
              </div>
              <p className="lead mb-4">{subtitle}</p>
              <div className="mb-4">
                {description}
              </div>
              <Button variant="primary" onClick={() => navigate('/contact')}>Contact Sales</Button>
            </Col>
            <Col lg={6}>
              <img 
                src={mainImage} 
                alt={title} 
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Key Benefits */}
      <section className="py-5 bg-light">
        <Container>
          <h2 className="text-center mb-5">Key Benefits</h2>
          <Row xs={1} md={2} lg={3} className="g-4">
            {benefits.map((benefit, idx) => (
              <Col key={idx}>
                <Card className="h-100 shadow-sm border-0">
                  <Card.Body>
                    <div className="d-flex align-items-center mb-3">
                      <div className="benefit-icon me-3">
                        {benefit.icon || <i className="fas fa-check-circle text-primary"></i>}
                      </div>
                      <h3 className="h5 mb-0">{benefit.title}</h3>
                    </div>
                    <Card.Text>{benefit.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Use Cases */}
      {useCases.length > 0 && (
        <section className="py-5">
          <Container>
            <h2 className="text-center mb-5">Common Use Cases</h2>
            <Row className="g-4">
              {useCases.map((useCase, idx) => (
                <Col key={idx} md={6} lg={4}>
                  <div className="use-case p-4 h-100 border rounded">
                    <h3 className="h5 mb-3">{useCase.title}</h3>
                    <p className="mb-0">{useCase.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      )}





      {/* Back button */}
      <Container className="py-4">
        <Button variant="link" onClick={() => navigate(-1)}>
          <i className="fas fa-arrow-left me-2"></i> Back to all features
        </Button>
      </Container>
    </div>
  );
};

export default FeatureDetail;
